import React, { useEffect, useState } from 'react';
import { AiOutlineBell, AiOutlineUser } from 'react-icons/ai';
import { FaCog, FaUsers, FaUpload, FaMoneyBill, FaSignOutAlt, FaList } from 'react-icons/fa';
import { MdBarChart, MdDashboard, MdWorkspacesFilled } from 'react-icons/md';
import { Outlet, useLocation, NavLink  } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../helpers';
import { BsPersonWorkspace } from 'react-icons/bs';
import { GiCheckeredDiamond } from 'react-icons/gi';
import { ImCheckboxChecked } from 'react-icons/im';
import { BiUser } from 'react-icons/bi';


export default function Userlayout() {

    const auth = useAuth();


    const check = async () =>{
  
    }

    useEffect(()=>{
      check()
    }, [])

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();
    const currentUrl = location.pathname + location.search;
  
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  
    const routes = [
      // { path: '/admin', name: 'Dashboard', icon: <MdDashboard className="mr-2" /> },
      { path: '/dealer', name: 'Processed Stock', icon: <ImCheckboxChecked className="mr-2" /> },
      { path: '/dealer/transactions', name: 'Transactions', icon: <FaList className="mr-2" /> },
    ];

    const signOut = () => {
      auth.logOut(()=>{
        window.location.href="/admin"
      })
  
    }

return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div className={`w-1/5 fixed h-[100%] text-lg bg-green-700 text-white pr-4 pt-4 shadow-lg fixedh-[90vh] transform  lg:translate-x-0 transition-transform duration-300 ease-in-out`}>
        <div className="mb-5 text-center font-bold">
          <img src="/logo1.png" alt="Logo" className="mx-auto w-1/3 my-5" />
        </div>

        <hr className='my-5 opacity-0'/>
        <ul className="space-y-2 mt-5">
          {routes.map((route) => (
            <li
              key={route.path}
              className={`text-lg border-blue-900 rounded-r-3xl cursor-pointer py-4 px-4 my-4 flex items-center ${currentUrl === route.path ? 'bg-white text-black pl-0 ml-0' : ''}`}
            >
              <NavLink to={route.path} className="flex items-center w-full">
                {route.icon} {route.name}
              </NavLink>
            </li>
          ))}
        </ul>

        <hr className='my-5' />

        <div onClick={signOut} className='flex items-center ml-5 cursor-pointer'>
        <FaSignOutAlt title='logout' className='text-2xl mr-1'/>
          signOut
        </div>

      </div>

      {/* Main Content */}
      <div className={`p-6 ml-auto w-full lg:w-4/5`} id="main-content">
        <div className="bg-white rounded-lg shadow p-4 mb-4">
          <header className="flex justify-between items-center">
           
           <input type="text" className='border border-green-700 p-5 rounded-2xl w-1/2' placeholder='search' />
           
            <div className="flex items-center space-x-4">
              <a href="#" className="relative text-gray-800 flex items-center">
                <AiOutlineBell size={30} className='m-2'/>
              </a>
              <a className="text-gray-800 flex items-center">
                <AiOutlineUser size={30} className='m-2'/>
              </a>
            </div>
          </header>
        </div>

        <Outlet />

        <div className="bg-white rounded-lg shadow p-2 mt-4">
          <footer className="text-center">
            &copy; 2023. All rights reserved.
          </footer>
        </div>
      </div>
    </div>
  );

}